import { createReducer, on } from '@ngrx/store';
import { RouterActions } from '@actions/index'

export interface State {
  currentRoute: String;
  previousRoute: String;
}

const initialState: State = {
  currentRoute: "",
  previousRoute: "",
};

export const reducer = createReducer(
  initialState,
  // Even thought the `state` is unused, it helps infer the return type
  on(RouterActions.changeCurrentRoute, (state, { newCurrentRoute }) => {
    const previousRoute = state.currentRoute;
    return { ...state, currentRoute: newCurrentRoute, previousRoute };
  }),
  on(RouterActions.navigateAuth, () => ({ ...initialState })),
);

export const getCurrentRoute = (state: State) => state.currentRoute;
